export class RecurrenceError extends Error {
  constructor(message: string, public readonly code: string) {
    super(message);
    this.name = 'RecurrenceError';
  }
}

export const RecurrenceErrorCodes = {
  INVALID_RANGE: 'invalid_range',
  INVALID_KIND: 'invalid_kind',
  MISSING_EXPLICIT: 'missing_explicit_for_custom',
  EMPTY_RANGE: 'empty_range',
  GENERATOR_NOT_FOUND: 'generator_not_found',
} as const;
